/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { nanoid } from 'nanoid';

export const generateNanoId = (): string => nanoid(12);

// Nano ID uses a bigger alphabet, so a similar number of random bits are packed in just 21 symbols instead of 36.
export const generateUUID = (): string => nanoid();
